export enum ParentInviteCategory {
    MegaChallengeInvites = 'MegaChallengeInvites',
    CompanyChallengeInvites = 'CompanyChallengeInvites',
    PersonalChallengeInvites = 'PersonalChallengeInvites'
}
